"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Word = function (_a) {
    var value = _a.value, variant = _a.variant, _b = _a.className, className = _b === void 0 ? '' : _b, children = _a.children, automatedTestId = _a.automatedTestId, errorId = _a.errorId, textStyle = _a.textStyle, loading = _a.loading;
    var classNameValue = "sds-word " + textStyle + " " + (loading ? 'loading' : '') + " " + (className || '');
    switch (variant) {
        case 'h1':
            return (react_1.default.createElement("h1", { className: classNameValue, id: automatedTestId, "data-testid": automatedTestId },
                value,
                children));
        case 'h2':
            return (react_1.default.createElement("h2", { className: classNameValue, id: automatedTestId, "data-testid": automatedTestId },
                value,
                children));
        case 'h3':
            return (react_1.default.createElement("h3", { className: classNameValue, id: automatedTestId, "data-testid": automatedTestId },
                value,
                children));
        case 'h4':
            return (react_1.default.createElement("h4", { className: classNameValue, id: automatedTestId, "data-testid": automatedTestId },
                value,
                children));
        case 'h5':
            return (react_1.default.createElement("h5", { className: classNameValue, id: automatedTestId, "data-testid": automatedTestId },
                value,
                children));
        case 'h6':
            return (react_1.default.createElement("h6", { className: classNameValue, id: automatedTestId, "data-testid": automatedTestId },
                value,
                children));
        case 'p':
            return (react_1.default.createElement("p", { className: classNameValue, id: automatedTestId || errorId, "data-testid": automatedTestId },
                value,
                children));
        case 'span':
            return (react_1.default.createElement("span", { className: classNameValue, id: automatedTestId, "data-testid": automatedTestId },
                value,
                children));
        default:
            return (react_1.default.createElement("p", { className: classNameValue, id: automatedTestId, "data-testid": automatedTestId },
                value,
                children));
    }
};
exports.default = Word;
